import { FEATURES } from 'consts/feature/const';
import * as pages from 'pages';

export const ROUTES = {
  // --------------------------------------------------
  // 404 Not Found
  // --------------------------------------------------
  NOT_FOUND: {
    PATH: '*',
    COMPONENT: pages.Error404PageComponent,
  },

  // --------------------------------------------------
  // Embed
  // --------------------------------------------------
  EMBED: {
    PATH: '/embed',

    REPORT: {
      PATH: '/embed/report/:EMBED_TOKEN',
      COMPONENT: pages.EmbedReportComponent,
    },
  },

  // --------------------------------------------------
  // Public
  // --------------------------------------------------
  PUBLIC: {
    PATH: '/public',
  },

  // --------------------------------------------------
  // Root (메인)
  // --------------------------------------------------
  ROOT: {
    PATH: '/',
    COMPONENT: pages.MainPageComponent,
  },

  // --------------------------------------------------
  // Auth (로그인 / 인증)
  // --------------------------------------------------
  LOGIN: {
    PATH: '/login',
    COMPONENT: pages.LoginPageComponent,
  },

  AUTH_CALLBACK: {
    PATH: '/auth-callback',
    COMPONENT: pages.AuthCallbackPageComponent,
  },

  // --------------------------------------------------
  // Library
  // --------------------------------------------------
  LIBRARY: {
    PATH: '/library',

    DATASETS: {
      PATH: '/library/datasets',
      COMPONENT: FEATURES.S_CORE_MODE
        ? pages.LibraryDatasetOnlyPageComponent
        : pages.LibraryDatasetsPageComponent,
    },
    DATASOURCES: {
      PATH: '/library/data-sources',
      COMPONENT: pages.LibraryDatasourcesPageComponent,
    },
    LOGS: {
      PATH: '/library/logs',
      COMPONENT: pages.LibraryLogsPageComponent,
    },
  },

  // --------------------------------------------------
  // Mart
  // --------------------------------------------------
  MART: {
    PATH: '/mart',

    ANSWERSET: {
      PATH: '/mart/answersets',
      COMPONENT: FEATURES.S_CORE_MODE
        ? pages.LibraryAnswersetOnlyPageComponent
        : pages.Error404PageComponent,
    },
    LOGS: {
      PATH: '/mart/logs',
      COMPONENT: FEATURES.S_CORE_MODE
        ? pages.LibraryLogsPageComponent
        : pages.Error404PageComponent,
    },
  },

  // --------------------------------------------------
  // Manual
  // --------------------------------------------------
  MANUAL: {
    PATH: '/manual',
    COMPONENT: pages.ManualPageComponent,
  },

  // --------------------------------------------------
  // Project
  // --------------------------------------------------
  PROJECT: {
    PATH: '/project',

    LIST: {
      PATH: '/project/list',
      COMPONENT: pages.ProjectListComponent,
    },
    DATA: {
      PATH: '/project/:PROJECT_ID',
      COMPONENT: pages.ProjectDataComponent,
    },
    JUPYTER: {
      PATH: '/project/jupyter',
      COMPONENT: FEATURES.S_CORE_MODE
        ? pages.ExternalJupyterPageComponent
        : pages.Error404PageComponent,
    },
  },

  // --------------------------------------------------
  // Flow
  // --------------------------------------------------
  FLOW: {
    PATH: '/flow',

    FLOWS: {
      PATH: '/flow/flows',
      COMPONENT: pages.FlowFlowsComponent,
    },
    GROUPS: {
      PATH: '/flow/groups',
      COMPONENT: pages.FlowGroupsComponent,
    },
    LOGS: {
      PATH: '/flow/logs',
      COMPONENT: pages.FlowLogsComponent,
    },
  },

  // --------------------------------------------------
  // Report
  // --------------------------------------------------
  REPORT: {
    PATH: '/report',

    DRAFT_LIST: {
      PATH: '/report/drafts',
      COMPONENT: pages.ReportDraftsListComponent,
    },
    DRAFT_DATA: {
      PATH: '/report/draft/:REPORT_ID',
      TO: (id: string) => `/report/draft/${id}`,
      COMPONENT: pages.ReportDraftComponent,
    },
    PUBLISH_LIST: {
      PATH: '/report/publish',
      COMPONENT: pages.ReportPublishListComponent,
    },
    PUBLISH_DATA: {
      PATH: '/report/publish/:REPORT_ID',
      TO: (id: string) => `/report/publish/${id}`,
      COMPONENT: pages.ReportPublishComponent,
    },
    CONNECTION_LIST: {
      PATH: '/report/connections',
      COMPONENT: pages.ReportConnectionListComponent,
    },
    CONNECTION_DATA: {
      PATH: '/report/connection/:REPORT_ID',
      TO: (id: string) => `/report/connection/${id}`,
      COMPONENT: pages.ReportConnectionComponent,
    },
  },

  // --------------------------------------------------
  // Admin (유저 및 시스템 관리)
  // --------------------------------------------------
  ADMIN: {
    PATH: '/admin',

    USERS: {
      PATH: '/admin/users',
      COMPONENT: pages.AdminUsersPageComponent,
    },
    GROUPS: {
      PATH: '/admin/groups',
      COMPONENT: pages.AdminGroupsPageComponent,
    },
    ROLES: {
      PATH: '/admin/roles',
      COMPONENT: pages.AdminRolesPageComponent,
    },
    CONNECTORS: {
      PATH: '/admin/connectors',
      COMPONENT: pages.AdminConnectorsPageComponent,
    },
    DOMAINS: {
      PATH: '/admin/domains',
      COMPONENT: pages.AdminDomainsPageComponent,
    },
    USER_LOGS: {
      PATH: '/admin/userLogs',
      COMPONENT: pages.AdminUserLogsPageComponent,
    },
    MONITORING: {
      PATH: '/admin/monitoring',
      COMPONENT: pages.AdminLogsPageComponent,
    },
  },

  // --------------------------------------------------
  // External
  // --------------------------------------------------
  EXTERNAL: {
    PATH: '/external',

    JUPYTER: {
      PATH: '/external/jupyter',
      COMPONENT: pages.ExternalJupyterPageComponent,
    },
    AUTH: {
      PATH: '/external/auth',
      COMPONENT: pages.ExternalAuthPageComponent,
    },
  },
};
